import React from "react";
import { Link } from "react-router-dom";

/**
 * การ์ดอินโฟกราฟิก — ภาพแนวตั้ง (ตัดให้พอดีกรอบ 4:5 ยึดขอบบน) + ชื่อด้านล่าง
 * ทั้งการ์ดเป็นลิงก์ไปหน้ารายละเอียด
 */
export default function InfographicCard({ data, lang }) {
  const cover = data.images[0];
  const title =
    lang === "en"
      ? data.title?.detail_EN || data.title?.detail_TH
      : data.title?.detail_TH || data.title?.detail_EN;

  return (
    <Link
      to={`/${lang}/infographic/${data.slug}`}
      className="group flex flex-col h-full bg-white rounded-[8px] overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.14)] transition-shadow"
    >
      <div className="w-full aspect-[4/5] bg-lightGray overflow-hidden">
        {cover && (
          <img
            src={`${process.env.REACT_APP_API_URL}${cover.formats?.medium?.url || cover.url}`}
            alt={title || ""}
            loading="lazy"
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-300"
          />
        )}
      </div>
      <p className="px-[16px] py-[14px] text-body font-bold text-slateGray text-left leading-snug line-clamp-3 group-hover:text-brand transition-colors">
        {title}
      </p>
    </Link>
  );
}
